import React, { useEffect, useState } from "react";
import "./QuoteSection.css";  
import { useSelector } from "react-redux";

const QuotesSection = () => {
  // const [quotesContent, setQuotesContent] = useState("");
  const {page} = useSelector((state) => state.data);


  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = page;
       
        // if (response.statusCode === 200 && response.data.quotes_section) {
          
        //   setQuotesContent(decode(response.data.data.quotes_section.htmlContent));
        // }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, [page]);

  return (
    <div>
      {/* {quotesContent ? (
        <div className="QuotesSection" dangerouslySetInnerHTML={{ __html: fixImagePaths(quotesContent) }} />
      ) : (
        <p>Loading...</p>
      )} */}
    </div>
  );
};

export default QuotesSection;